import axios from "axios";
export const DASHBOARD_DATA = `/api/v1/customer/dashboard`;
export const CAMPAIGN_DATA = `/api/v1/customer/campaign-details`;
export const NSU_CASHBACK = `/api/v1/customer/nsu-cashback-details`;

export function getDashboardData() {
  return axios.get(DASHBOARD_DATA, {
    validateStatus(status) {
      return true;
    },
  });
}
export function getCampaignDetails() {
  return axios.get(CAMPAIGN_DATA, {
    validateStatus(status) {
      return true;
    },
  });
}
export function getNsuCashbackDetails() {
  return axios.get(NSU_CASHBACK, {
    validateStatus(status) {
      return true;
    },
  });
}

export const getRestaurantPageData = (restaurantPrefix) => {
  return axios.get(`/api/v1/user/restaurant-page/${restaurantPrefix}`, {
    validateStatus(status) {
      return true;
    },
  });
};
